<template>
    <div class="simplest-grid">
        <CRow>
            <CCol col>
                <ejs-grid ref='grid' :dataSource="officeData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin="actionBegin" :actionComplete='actionComplete' :actionFailure="actionFailure" :filterSettings='filterOptions'>
                    <e-columns>
                        <e-column field='officeId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='name' headerText='Name' :validationRules="requiredRules" width=120></e-column>
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
    </div>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions';
    import store from '../../../store';

    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        components: {
        },
        data() {
            return {
                store: store,
                officeData: SyncHelper.getDataManager("offices"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.Offices.Update"],
                    allowAdding: store.state.permissions["Permissions.Offices.Create"],
                    allowDeleting: store.state.permissions["Permissions.Offices.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true, maxLength: 512 },
                symbolRules: { required: true, maxLength: 10 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "offices.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
</style>
